import React from 'react';
import { FadeIn } from './ui/FadeIn';
const bonuses = [{
  num: '01',
  title: 'Lista de compras SOS 🛒',
  desc: 'Todo lo que necesitás para arrancar el protocolo de 72hs. Ingredientes reales, menos de $3.000 ARS, disponibles en cualquier dietética o supermercado argentino. Sin vueltas, sin excusas.'
}, {
  num: '02',
  title: 'Guía de suplementación con precios ARS actualizados 💊',
  desc: 'Los suplementos que realmente funcionan para hinchazón, ansiedad y energía. Marcas argentinas, dónde comprarlos y cuánto cuestan hoy. Sin gastar de más.'
}, {
  num: '03',
  title: 'Plan de 21 días integrado 📅',
  desc: 'Un plan paso a paso para integrar todo lo que aprendiste. Sin improvisación, sin recaídas. Sabés exactamente qué hacer cada día.'
}];
export function Bonuses() {
  return <section className="py-16 md:py-20 bg-brand-card border-y border-brand-border" data-id="element-21">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-22">
        <FadeIn data-id="element-23">
          <div className="bg-white border border-brand-verifiedGreen/40 rounded-3xl shadow-card p-6 md:p-10" data-id="element-24">
            {/* Title */}
            <h2 className="text-2xl md:text-3xl font-extrabold text-brand-accent text-center mb-3 leading-tight" data-id="element-25">
              🎁 BONOS EXCLUSIVOS — Solo con tu compra hoy
            </h2>

            {/* Subtitle */}
            <p className="text-center text-sm md:text-base font-medium text-brand-terracotta mb-8" data-id="element-26">
              ⚠️ Estos bonos desaparecen si cerrás esta página
            </p>

            {/* Bonuses grid */}
            <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8" data-id="element-27">
              {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-28">
                  <div className="h-full bg-brand-cream border border-brand-border rounded-2xl p-5 flex flex-col hover:border-brand-accent transition-colors shadow-sm" data-id="element-29">
                    <span className="self-start inline-block text-xs font-extrabold text-white bg-brand-verifiedGreen px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-30">
                      BONO {bonus.num}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-brand-dark leading-tight mb-3" data-id="element-31">
                      {bonus.title}
                    </h3>
                    <p className="text-brand-muted text-sm leading-relaxed" data-id="element-32">
                      {bonus.desc}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            {/* Value summary */}
            <FadeIn delay={0.35} data-id="element-33">
              <div className="bg-brand-softGreen border-2 border-dashed border-brand-verifiedGreen rounded-2xl p-5 md:p-6 text-center" data-id="element-34">
                <p className="text-base md:text-lg font-bold text-brand-dark leading-snug" data-id="element-35">
                  💰 Valor total de los bonos:{' '}
                  <span className="line-through text-brand-muted font-medium" data-id="element-36">
                    $9.000 ARS
                  </span>{' '}
                  — Hoy los recibís{' '}
                  <span className="text-brand-accent font-extrabold uppercase" data-id="element-37">
                    GRATIS
                  </span>{' '}
                  con tu compra
                </p>
              </div>
            </FadeIn>

            {/* Urgency line */}
            <p className="text-center mt-5 text-sm italic text-brand-terracotta font-medium" data-id="element-38">
              ⏳ Solo disponibles mientras dure esta oferta
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}